import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';
import { authFeatureKey } from './auth.reducer';

// Selector para el feature state 'auth'
export const selectAuthState = createFeatureSelector<AuthState>(authFeatureKey);

// Selectores para partes específicas del AuthState
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated
);

export const selectUser = createSelector(selectAuthState, (state: AuthState) => state.user);

export const selectAuthToken = createSelector(selectAuthState, (state: AuthState) => state.token);

export const selectAuthError = createSelector(selectAuthState, (state: AuthState) => state.error);

export const selectIsAuthInitializing = createSelector(
  selectAuthState,
  (state: AuthState) => state.initializing
);

export const selectAuthLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.loading
);
